export default __webpack_public_path__ + "static/media/blue_5.3cbec5fe.png";